<div class="page-body">
  <!--community cover start-->
  <div class="row">
    <!-- Right column start -->
    <div class="col-xl-3 col-12">
      <community-card [community]="community"></community-card>
    </div>
    <!-- Right column end -->

    <!-- Left column start -->
    <div class="col-xl-9 col-12">
      <community-nav-tabs [community]="community"></community-nav-tabs>
      <router-outlet></router-outlet>
    </div>
    <!-- Left column end -->
  </div>
</div>
